export default "__VITE_ASSET__BcVPGddQ__"